import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="container max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* О компании */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src={companyInfo.logo} alt="AVK SPORT" className="h-11 w-auto brightness-0 invert" />
              <div>
                <div className="text-lg font-bold text-white tracking-tight leading-none">AVK</div>
                <div className="text-xs font-semibold text-white tracking-widest uppercase">SPORT</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Профессиональное производство хоккейной формы и экипировки для команд любого уровня
            </p>
          </div>

          {/* Навигация */}
          <div>
            <p className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Навигация</p>
            <nav className="flex flex-col gap-3">
              <Link to="/catalog" className="text-gray-400 hover:text-white text-sm transition-colors">Каталог</Link>
              <Link to="/calculator" className="text-gray-400 hover:text-white text-sm transition-colors">Калькулятор</Link>
              <Link to="/order" className="text-gray-400 hover:text-white text-sm transition-colors">Заказать</Link>
              <Link to="/portfolio" className="text-gray-400 hover:text-white text-sm transition-colors">Портфолио</Link>
              <Link to="/reviews" className="text-gray-400 hover:text-white text-sm transition-colors">Отзывы</Link>
              <Link to="/detskaya-forma" className="text-gray-400 hover:text-white text-sm transition-colors">Детская форма</Link>
              <Link to="/gamashi" className="text-gray-400 hover:text-white text-sm transition-colors">Хоккейные гамаши</Link>
              <Link to="/optom" className="text-gray-400 hover:text-white text-sm transition-colors">Оптовикам</Link>
              <Link to="/moskva" className="text-gray-400 hover:text-white text-sm transition-colors">Доставка в Москву</Link>
              <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors">О компании</Link>
              <Link to="/contacts" className="text-gray-400 hover:text-white text-sm transition-colors">Контакты</Link>
              <a href="https://avik.site/rodkom" className="text-gray-400 hover:text-white text-sm transition-colors">Кабинет родкома</a>
              <a href="https://shop.avk-pro.ru/sport" className="text-gray-400 hover:text-white text-sm transition-colors">Магазин клуба</a>
            </nav>
          </div>

          {/* Категории товаров */}
          <div>
            <p className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Продукция</p>
            <ul className="flex flex-col gap-3 text-sm text-gray-400">
              <li>Хоккейные джерси</li>
              <li>Гамаши</li>
              <li>Форма для зала</li>
              <li>Чехлы для шорт</li>
              <li>Бомберы и куртки</li>
              <li>Жилетки</li>
            </ul>
          </div>

          {/* Контакты */}
          <div>
            <p className="text-sm font-semibold mb-6 text-white uppercase tracking-wider">Контакты</p>
            <div className="flex flex-col gap-4 text-sm text-gray-400">
              <a href={`tel:${companyInfo.phone}`} className="flex items-start gap-3 hover:text-white transition-colors">
                <Phone size={16} className="mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{companyInfo.phone}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-start gap-3 hover:text-white transition-colors">
                <Mail size={16} className="mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{companyInfo.email}</span>
              </a>
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{companyInfo.address}</span>
              </div>
              <div className="flex items-start gap-3">
                <Clock size={16} className="mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                <span>{companyInfo.workHours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-6 text-sm text-gray-400">
            <p>&copy; 2026 AVK SPORT. Все права защищены.</p>
            <div className="flex flex-wrap gap-6 justify-center">
              <Link to="/legal/privacy" className="hover:text-white transition-colors">
                Политика конфиденциальности
              </Link>
              <Link to="/legal/terms" className="hover:text-white transition-colors">
                Пользовательское соглашение
              </Link>
              <Link to="/legal/cookies" className="hover:text-white transition-colors">
                Использование cookie
              </Link>
              <Link to="/legal/requisites" className="hover:text-white transition-colors">
                Реквизиты
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;